import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import avatar from "assets/img/faces/avatar.png";

import { Route, Redirect } from "react-router-dom";
import lockScreenPageStyle from "assets/jss/material-dashboard-pro-react/views/lockScreenPageStyle.jsx";
import firebase from "firebase/app";
import "firebase/auth";

import LoginAlert from "./LoginAlert.jsx";

class LockScreenPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      email: "admin@moneyledgers.com",
      password: "",
      user: null,
      alert: null,
      show: false
    };
    this.change = this.change.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.loginFailedMessage = this.loginFailedMessage.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.unsubscribe = null;
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );

    this.unsubscribe = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({
          user: user
        });
      } else {
        this.setState({
          user: null
        });
      }
    });
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
    this.unsubscribe();
  }

  handleLogin(event) {
    event.preventDefault();
    firebase
      .auth()
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .catch(error => {
        this.loginFailedMessage(error.message);
      });
  }

  change(event, type) {
    switch (type) {
      case "password":
        this.setState({
          password: event.target.value
        });
        break;
      case "email":
        this.setState({
          email: event.target.value
        });
        break;
      default:
        break;
    }
  }

  loginFailedMessage(message) {
    this.setState({
      alert: <LoginAlert message={message} hideAlert={this.hideAlert} />
    });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  render() {
    const { classes } = this.props;
    if (this.state.user != null) {
      return (
        <Route>
          <Redirect to={"/dashboard"} />
        </Route>
      );
    }
    return (
      <div className={classes.container}>
      {this.state.alert}
        <form onSubmit={this.handleLogin}>
          <Card
            profile
            className={
              classes.customCardClass + " " + classes[this.state.cardAnimaton]
            }
          >
            <CardAvatar profile className={classes.cardAvatar}>
              <a href="#pablo" onClick={e => e.preventDefault()}>
                <img src={avatar} alt="..." />
              </a>
            </CardAvatar>
            <CardBody profile>
              <h4 className={classes.cardTitle}>Steve Penner</h4>
              <CustomInput
                labelText="Enter Password"
                id="company-disabled"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "password",
                  onKeyPress: event => {
                    if (event.key === "Enter") this.handleLogin(event);
                  },
                  onChange: event => this.change(event, "password")
                }}
              />
            </CardBody>
            <CardFooter className={classes.justifyContentCenter}>
              <Button color="rose" round onClick={this.handleLogin}>
                Unlock
              </Button>
            </CardFooter>
          </Card>
        </form>
      </div>
    );
  }
}

LockScreenPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(lockScreenPageStyle)(LockScreenPage);



// WEBPACK FOOTER //
// ./src/views/Pages/LockScreenPage.jsx